import React, { useState, useEffect } from 'react';
import Icon from 'components/Icon';
import '../../styles/global.scss';
import './Scroller.scss';

const Index = ({
	containerElement,
	scrollingElement,
	scrollToTop = false,
	scrollAmount,
	behavior = 'smooth',
}) => {
	const [locationClass, setLocationClass] = useState('');

	const scrollUp = () => {
		if ((scrollAmount === undefined || scrollToTop === true) && scrollingElement !== undefined) {
			containerElement.scrollTo({
				top: 0,
				behavior: behavior,
			});
		} else {
			containerElement.scrollBy({
				top: -scrollAmount,
				behavior: behavior,
			});
		}
	};

	const scrollDown = () => {
		if (scrollAmount === undefined && scrollingElement !== undefined) {
			containerElement.scrollTo({
				top: scrollingElement.offsetHeight,
				behavior: behavior,
			});
		} else if (scrollLocation() === 'hero' || scrollLocation() === 'page-top') {
			containerElement.scrollTo({
				top: document.querySelector('.main__content').offsetTop,
				behavior: behavior,
			});
		} else {
			containerElement.scrollBy({
				top: scrollAmount,
				behavior: behavior,
			});
		}
	};

	const scrollLocation = () => {
		if (containerElement.scrollTop === 0) {
			return 'page-top';
		} else if (Math.abs(containerElement.scrollTop - containerElement.offsetHeight) <= 10) {
			return 'content-top';
		} else {
			if (
				containerElement.scrollTop + containerElement.clientHeight ===
				scrollingElement.offsetHeight
			) {
				return 'page-bottom';
			} else {
				if (containerElement.scrollTop < containerElement.offsetHeight) {
					return 'hero';
				} else if (containerElement.scrollTop === scrollingElement.offsetHeight) {
					return 'page-bottom';
				} else if (containerElement.scrollTop > containerElement.offsetHeight) {
					return 'content';
				}
			}
		}
	};

	useEffect(() => {
		setLocationClass(scrollLocation());

		containerElement.addEventListener(
			'scroll',
			() => {
				setLocationClass(scrollLocation());
			},
			{ passive: true },
		);

		return () => containerElement.removeEventListener('scroll', setLocationClass);
	});

	return (
		<div className={`scroll-icons-wrapper ${locationClass}`}>
			<Icon classes={['icon--up']} name="arrow-up" handleClick={scrollUp} />
			<Icon classes={['icon--down']} name="arrow-down" handleClick={scrollDown} />
		</div>
	);
};

export default Index;
